// The app-level OCC retry ladder's shape, in one place. Three stores run a ladder — the front desk
// registering a player, the admin writing the project registry, and the door redeeming a share code
// onto the grant table — and three copies of the band would be three chances to drift out of the
// window docs/sync.md pins.

// Three attempts total, one backoff between each. The scout measured twelve devices bursting at one
// aggregate; at 250ms spacing or wider there were no conflicts at all.
export const MAX_ATTEMPTS = 3;
// The jitter band docs/sync.md pins. Three orders of magnitude inside the SDK's 90-second dedup
// window, which is what makes reusing one idempotency key across attempts safe.
export const MIN_BACKOFF_MS = 80;
export const MAX_BACKOFF_MS = 300;

// Deterministic jitter in the band, derived from this write's own idempotency key and the attempt
// number. Math.random is banned in this repo (nothing a device derives may be irreproducible), and
// a fixed delay would have every conflicting device wake up together and collide again. A UUID
// differs per device and per write, which is exactly the decorrelation the jitter is for.
export function backoffMs(seed: string, attempt: number): number {
  let hash = 5381;
  const material = `${seed}:${attempt}`;
  for (let i = 0; i < material.length; i++)
    hash = ((hash << 5) + hash + material.charCodeAt(i)) | 0;
  const span = MAX_BACKOFF_MS - MIN_BACKOFF_MS + 1;
  return MIN_BACKOFF_MS + (Math.abs(hash) % span);
}
